import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { howMadeMessages as messages } from '../messages/howMadeMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for "How it was made"; each part uses its own slice of it */
import styles from './HowMade.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface HowMadeRoundsProps {
  count: number;
  shown: number;
  picked: number;
  onShow: (index: number) => void;
}

/** The round switch of a step (design l1 `.rounds`): one button per round; the picked one says so. */
const HowMadeRoundsComponent: React.FC<HowMadeRoundsProps> = ({ count, shown, picked, onShow }) => {
  const intl = useIntl();
  if (count < 2) {
    return null;
  }
  return (
    <div className={styles.rounds} role="group" aria-label={intl.formatMessage(messages.roundsLabel)}>
      {Array.from({ length: count }, (_, index) => (
        <button
          // eslint-disable-next-line react/no-array-index-key -- the rounds never change order
          key={index}
          type="button"
          className={clsx(styles.round, index === shown && styles.roundOn)}
          aria-pressed={index === shown}
          onClick={() => onShow(index)}
        >
          {intl.formatMessage(index === picked ? messages.roundPicked : messages.round, { number: index + 1 })}
        </button>
      ))}
    </div>
  );
};

export const HowMadeRounds = TypedMemo(HowMadeRoundsComponent);
